

let intercept

/**
 * 禁用浏览器的后退按钮，并执行回调函数。恢复时需要手动调用recoverDisableBack
 */
const disableBack = function(callback) {
    if (typeof window) {
        window.history.pushState(null, null, window.location.href)
        intercept = function () {
            window.history.go(1)
            callback()
        }
        window.addEventListener('popstate', intercept)
    } else {
        return console.warn('disableBack just run in browser environment')
    }
}

const cancelDisableBack = function() {
    if (typeof window) {
        window.removeEventListener('popstate', intercept)
    }
}

/**
 * 恢复disableBack带来的副作用
 */
const recoverDisableBack = function() {
    if (typeof window) {
        window.removeEventListener('popstate', intercept)
        window.history.back()
    } else {
        return console.warn('recoverDisableBack just run in browser environment')
    }
}

export {
    disableBack,
    cancelDisableBack,
    recoverDisableBack
}
